// App-locale date formatting; pass intl.locale. Day-first, separator by language.

function parse(value: string | Date | null | undefined): Date | null {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function separator(locale: string): string {
  return locale.toLowerCase().startsWith("de") ? "." : "/";
}

/** dd/MM/yyyy (en) or dd.MM.yyyy (de). Empty string for missing/invalid input. */
export function formatDate(value: string | Date | null | undefined, locale: string): string {
  const d = parse(value);
  if (!d) return "";
  const sep = separator(locale);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}${sep}${mm}${sep}${d.getFullYear()}`;
}

/** Same date format plus a 24-hour HH:mm clock. Empty string for missing input. */
export function formatDateTime(value: string | Date | null | undefined, locale: string): string {
  const d = parse(value);
  if (!d) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(d, locale)} ${hh}:${min}`;
}
